module.exports = require("wrong-module");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-module4/index.js
 ** module id = 4
 ** module chunks = 0
 **/